import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import LoadingSpin from '@spa/shared/svg/loading-spin';
import { Wrapper } from './styles';

const ICON_SIDES = {
  LEFT: 'left',
  RIGHT: 'right'
};

const Button = ({
  children,
  isPrimary,
  isSecondary,
  isTertiary,
  isDanger,
  isGhost,
  isSelected,
  isSmall,
  isDisabled = false,
  isLoading = false,
  onClick = () => {},
  href,
  target = '_blank',
  icon: Icon = Fragment,
  iconSide = ICON_SIDES.RIGHT,
  ...props
}) => {
  const linkProps = href ? { href, target, rel: 'noreferrer', role: 'button' } : {};

  return (
    <Wrapper
      as={href ? 'a' : 'button'}
      onClick={onClick}
      isPrimary={isPrimary}
      isSecondary={isSecondary}
      isTertiary={isTertiary}
      isDanger={isDanger}
      isGhost={isGhost}
      isSelected={isSelected}
      isSmall={isSmall}
      isDisabled={isDisabled}
      isLoading={isLoading}
      iconSide={iconSide}
      icon={Icon}
      {...linkProps}
      {...props}
    >
      {iconSide === ICON_SIDES.LEFT && (isLoading ? <Loading /> : <Icon />)}
      <span>{children}</span>
      {iconSide === ICON_SIDES.RIGHT && (isLoading ? <Loading /> : <Icon />)}
    </Wrapper>
  );
};

const Loading = () => <LoadingSpin className="loading-spin" />;

Button.propTypes = {
  children: PropTypes.node,
  isPrimary: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isTertiary: PropTypes.bool,
  isDanger: PropTypes.bool,
  isGhost: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSmall: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.func,
  iconSide: PropTypes.oneOf([ICON_SIDES.LEFT, ICON_SIDES.RIGHT])
};

export default Button;
